// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Invoices_establishments__1QUJ8","header":"Invoices_header__8renh","tableHeader":"Invoices_tableHeader__u4UbP"};